import { createAction } from "redux-actions";

export const FAQ_LIST = "FAQ_LIST";
export const faqList = createAction(FAQ_LIST);

export const CREATE_FAQ = "CREATE_FAQ";
export const createFaq = createAction(CREATE_FAQ);

export const DETAIL_FAQ = "DETAIL_FAQ";
export const detailFaq = createAction(DETAIL_FAQ);

export const UPDATE_FAQ = "UPDATE_FAQ";
export const updateFaq = createAction(UPDATE_FAQ);

export const DELETE_FAQ = "DELETE_FAQ";
export const deleteFaq = createAction(DELETE_FAQ);
